import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface StatusPageProps {
  readonly title: string;
  readonly description: string;
  readonly action?: ReactNode;
  readonly icon?: ReactNode;
}

/** Shared frame for 403 / 404 / no-products — one look for every dead end. */
export function StatusPage({ title, description, action, icon }: StatusPageProps): ReactNode {
  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Stack spacing={1.5} sx={{ maxWidth: 460, textAlign: 'center', alignItems: 'center' }}>
        {icon !== undefined && <Box sx={{ color: 'text.disabled', display: 'flex' }}>{icon}</Box>}
        <Typography variant="h1" component="h1">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
        {action !== undefined && <Box sx={{ pt: 1 }}>{action}</Box>}
      </Stack>
    </Box>
  );
}

export { Button as StatusPageButton };
